import { render } from "./recent-action.vue?vue&type=template&id=38eae271&scoped=true"
import script from "./recent-action.vue?vue&type=script&lang=js"
export * from "./recent-action.vue?vue&type=script&lang=js"

import "./recent-action.vue?vue&type=style&index=0&id=38eae271&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38eae271"]])

export default __exports__